import type { Pool } from '~~/interfaces/poolDetail'
import type { PoolStationConnector } from '#cmui/types'
import type { PoolRealtimeState } from '#cmui/types/pool'

export enum AdministrativeState {
    PLANNED = 1,
    IN_DEPLOYMENT = 2,
    IN_MAINTENANCE = 3,
    IN_SERVICE = 4,
    OUT_OF_SERVICE = 5,
    DELETED = 6
}

export interface PoolStationManufacturer {
    id: number
    name: string
}

export interface PoolStationModel {
    id: number
    name: string
}

export interface PoolStationPaymentMean {
    id: number
    name: string
    icon: string | null
    belongsToChargemap: boolean
}

export interface PoolStationEvseOperationalState {
    id: number
    label: string
}

export interface PoolStationConnectorType {
    id: number
    label: string
    icon: string | null
    slug: string
}

export interface PoolStationAdministrativeState {
    id: number
    label: string
}

export interface PoolStationAuthenticationMethod {
    id: number
    label: string
}

export interface PoolStationConnectorRealtimeStatusCount {
    realtimeStatus: PoolRealtimeState | null
    count: number
}

export interface PoolStationConnectorForDisplay extends PoolStationConnector {
    realtimeStatusCount: PoolStationConnectorRealtimeStatusCount[]
}

export interface PoolStationEvse {
    id: number
    defaultEvseForCharging?: number | null
    operationalState: PoolStationEvseOperationalState
    connectors?: PoolStationConnector[] | null
}

export interface PoolStation {
    id: number
    label: string | null
    isFree: boolean
    needAuthentication: boolean
    canChargeWithChargemap: boolean
    administrativeState?: PoolStationAdministrativeState | null
    manufacturer?: PoolStationManufacturer | null
    model?: PoolStationModel | null
    authenticationMethods?: PoolStationAuthenticationMethod[] | null
    paymentMeans?: PoolStationPaymentMean[] | null
    evses: PoolStationEvse[] | []
}

export interface NearStation {
    distance: number
    icon: string
    lat: number
    lng: number
    pool: Pool
    type: string
}
